// ⚠️ AUTO-GENERATED — DO NOT EDIT MANUALLY
// Source: ./svg/IconPencil.svg — regenerate with `nx run creditflowresearch-uilib:icons-generate --write`
import BaseIcon from './BaseIcon';
import type { IIconProps } from './types';

const IconPencil = (props: IIconProps) => (
  <BaseIcon viewBox="0 0 16 16" fill="currentColor" { ...props }>
    <path d="M13.4643 0H12.9643L11.0357 1.93073L14.0714 4.96983L16 3.03911V2.53855L13.4643 0ZM1.39286 11.5844L0 16L4.41071 14.6056L12.8036 6.20335L9.76786 3.16425L1.39286 11.5844Z" />
  </BaseIcon>
);

export default IconPencil;
